module.exports = __webpack_public_path__ + "img/Facebook.773342cd.svg";